module.exports = __webpack_public_path__ + "img/folder.dc22a481.svg";